import { Button, Popconfirm } from "antd";
import { nullRenderer } from "features/billingCommissions/submitToBilling/tableColumns";
import K from "utilities/constants";
import { isPermissionPresent } from "utilities/generalUtility";
import { DefaultColumnOptions } from "../../../hooks/useDataGrid/options";

const phoneExtRenderer = (params) => params.data.phoneExt ?? K.NullPlaceholder;

const actionColumnRenderer =
  (userRoles, editRecord, confirmDelete) => (params) => {
    return (
      <>
        {isPermissionPresent(K.Permissions.EditClientContact, userRoles) && (
          <Button
            type="link"
            onClick={() => {
              editRecord(params.data);
            }}
            className="text-primary-light"
          >
            Edit
          </Button>
        )}
        {isPermissionPresent(K.Permissions.DeleteClientContact, userRoles) && (
          <Popconfirm
            title="Are you sure to delete this record?"
            onConfirm={() => {
              confirmDelete(params.data.id);
            }}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" style={{ color: "red" }}>
              Delete
            </Button>
          </Popconfirm>
        )}
      </>
    );
  };

export const getColumns = (userRoles, editRecord, confirmDelete) => [
  DefaultColumnOptions.Id,
  {
    headerName: "Full Name",
    field: "name",
    sortable: true,
    sort: "asc",
    tooltipField: "name",
  },
  {
    headerName: "Email",
    field: "email",
    sortable: true,
    tooltipField: "email",
  },
  {
    headerName: "Job Title",
    field: "jobTitle",
    sortable: true,
    tooltipField: "jobTitle",
  },
  {
    headerName: "Phone Number",
    field: "phoneNumber",
    sortable: true,
    tooltipField: "phoneNumber",
  },
  {
    headerName: "Phone Ext",
    field: "phoneExt",
    sortable: true,
    tooltipField: "phoneExt",
    tooltipComponent: phoneExtRenderer,
    cellRenderer: phoneExtRenderer,
  },
  {
    headerName: "Created By",
    field: "createdByName",
    sortable: true,
    tooltipField: "createdByName",
    ...nullRenderer,
  },
  {
    headerName: "Edited By",
    field: "updatedByName",
    sortable: true,
    tooltipField: "updatedByName",
    ...nullRenderer,
  },
  {
    ...DefaultColumnOptions.Actions,
    hide: !isPermissionPresent(K.Permissions.EditClientContact, userRoles) && !isPermissionPresent(K.Permissions.DeleteClientContact, userRoles),
    cellRenderer: actionColumnRenderer(userRoles, editRecord, confirmDelete),
  },
];
